module.exports = __webpack_public_path__ + "static/media/example_sidebar.6c3e62c8.png";